import { createGlobalPayment } from '@/api/tablet';
import { useMutation } from 'react-query';

const useCreateGlobalPayment = (userId: string, tabletId: string) => {
  return useMutation({
    mutationFn: ({
      totalPaymentAmount,
      totalPrice,
      isDirectPayment = false,
    }: {
      totalPaymentAmount?: number;
      totalPrice?: number;
      isDirectPayment?: boolean;
    }) =>
      createGlobalPayment(
        userId,
        tabletId,
        totalPaymentAmount,
        totalPrice,
        isDirectPayment,
      ),
  });
};

export default useCreateGlobalPayment;
